import { Grid } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import BlockTitle from '../../BlockTitle';
import ReportDesc from './ReportDesc';
import ReportName from './ReportName';
import ReportOrg from './ReportOrg';
import ReportServices from './ReportServices';

export const GeneralSetting = () => {
  const { t } = useTranslation();
  return (
    <>
      <BlockTitle
        id="generalSettingsTitle"
        content={t('reportCommon.titles.generalSettings')}
      />
      <Grid
        templateColumns="130px max-content"
        // columnGap="10x"
        rowGap="18px"
      >
        <ReportName />
        <ReportDesc />
        <ReportOrg />
        <ReportServices />
      </Grid>
    </>
  );
};
